enum GroupSavingsMethod {
  Shares = 'SHARE',
  Currency = 'CURRENCY',
}

export default GroupSavingsMethod;
